import {createAction as deprecatedCreateAction} from 'web-app/util/redux/famly-app-helpers';
import {createAction} from 'web-app/util/redux/typed-action-helpers';

import type * as Types from './types';

const domain = 'MODALS/MEDICATION_FORM';

export const {action: show} = deprecatedCreateAction(
    `${domain}/SHOW`,
    (childId: string, medicationFormId: string, institutionId: string, child?: Types.RequiredChildInformation) => ({
        childId,
        medicationFormId,
        institutionId,
        child,
    }),
);

export const {action: hide} = deprecatedCreateAction(`${domain}/HIDE`, () => ({}));

export const {action: setIsInEditMode} = createAction(`${domain}/SET_IS_IN_EDIT_MODE`, (isInEditMode: boolean) => ({
    isInEditMode,
}));
